import { render, staticRenderFns } from "./edits.vue?vue&type=template&id=1d283ec0&"
import script from "./edits.vue?vue&type=script&lang=js&"
export * from "./edits.vue?vue&type=script&lang=js&"
import style0 from "./edits.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports